import { render } from "./Message.vue?vue&type=template&id=eeec83fa"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
script.render = render

export default script